
export default {
  name: 'ButtonComponent',

  props: {
    text: {
      type: String,
      default: 'button'
    },
    href: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'arrow'
    },
    textColor: {
      type: String,
      default: 'black'
    },
    buttonColor: {
      type: String,
      default: 'white'
    },
    buttonBorderColor: {
      type: String,
      default: 'black'
    },
    target: {
      type: String,
      default: '_self'
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
    }
  },
  
  computed: {
    styles() {
      const styles = []
      if (this.buttonColor) {
        styles.push(
          {
            background: `${this.buttonColor}`
          }
        ) 
      }
      if (this.buttonBorderColor) {
        styles.push({
          'border-color': `${this.buttonBorderColor}`,
        })
      }
      return styles;
    },
    buttonStyles() {
      const styles = []
      if (this.textColor) {
        styles.push(
          {
            color: `${this.textColor}`
          }
        ) 
      }
      return styles;
    }
  }

}
